import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from './context/AuthContext';
import { 
  FaUserCog, 
  FaUserMd, 
  FaCalendarAlt, 
  FaChartBar, 
  FaHome, 
  FaBell, 
  FaCog, 
  FaSignOutAlt,
  FaTachometerAlt,
  FaUsers,
  FaBars,
  FaTimes
} from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import logo from './Designer.png';

const AdminNavbar = () => {
  const { currentUser, logout } = useAuth();
  const location = useLocation();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
const { navigate } = useNavigate();
  const handleLogout = async () => {
    try {
       
      await logout();
      navigate('/login');
    } catch (error) {
      console.error("Logout failed", error);
    }
  };

  const isActive = (path) => {
    return location.pathname === path;
  };

  const navLinks = [

    
  ];

  // Add this function near your other utility functions

// Helper function to create avatar initials from name
const getInitials = (firstName, lastName) => {
    return `${firstName?.charAt(0) || ''}${lastName?.charAt(0) || ''}`.toUpperCase();
  };
  
  // Add this default avatar component at the top of the file with your imports
  const Avatar = ({ user, size = "md" }) => {
    const initials = getInitials(user.firstName, user.lastName);
    const colors = {
      'admin': 'bg-purple-500',
      'doctor': 'bg-green-500',
      'patient': 'bg-blue-500'
    };
    
    const sizes = {
      'sm': 'w-8 h-8 text-xs',
      'md': 'w-10 h-10 text-sm',
      'lg': 'w-12 h-12 text-base'
    };
    
    return (
      <div className={`${sizes[size]} ${colors[user.role] || 'bg-gray-500'} rounded-full flex items-center justify-center text-white font-medium`}>
        {initials}
      </div>
    );
  };

  return (
    <nav className="bg-white shadow-md">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex justify-between h-16">
          {/* Logo and brand */}
          <div className="flex-shrink-0 flex items-center">
            <Link to="/" className="flex items-center">
              <img 
                className="h-8 w-auto" 
                src={logo} 
                alt="SeraphMed Logo"
              
              />
              
              <span className="ml-2 text-xl font-bold text-gray-900">SeraphMed</span>
              <span className="ml-2 bg-blue-100 text-blue-800 text-xs px-2 py-1 rounded-full">Admin</span>
            </Link>
          </div>

          {/* Desktop navigation */}
          <div className="hidden md:ml-6 md:flex md:items-center md:space-x-4">
            {navLinks.map((link) => (
              <Link
                key={link.name}
                to={link.path}
                className={`${
                  isActive(link.path)
                    ? 'bg-blue-50 text-blue-700'
                    : 'text-gray-500 hover:bg-gray-50 hover:text-gray-900'
                } px-3 py-2 rounded-md text-sm font-medium flex items-center`}
              >
                {link.icon}
                {link.name}
              </Link>
            ))}
          </div>
          
          {/* Mobile menu button */}
          <div className="md:hidden flex items-center">
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 focus:text-gray-500"
            >
              {mobileMenuOpen ? <FaTimes className="h-6 w-6" /> : <FaBars className="h-6 w-6" />}
            </button>
          </div>

          {/* Right side user menu */}
          <div className="hidden md:flex md:items-center">
            <div className="ml-4 flex items-center md:ml-6">
              {/* Notification bell */}
              {/* <button className="p-1 rounded-full text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500">
                <FaBell className="h-6 w-6" />
              </button> */}

              {/* Profile dropdown */}
              <div className="ml-3 relative">
                <div>
                  <button
                    onClick={() => setDropdownOpen(!dropdownOpen)}
                    className="max-w-xs bg-white flex items-center text-sm rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                  >
                    <div className="h-8 w-8 rounded-full bg-blue-100 flex items-center justify-center text-blue-800">
                      {currentUser?.firstName?.charAt(0) || 'A'}
                    </div>
                  </button>
                </div>

                {/* Dropdown menu */}
                {dropdownOpen && (
                  <div className="origin-top-right absolute  right-0 mt-2 w-fit rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 divide-y divide-gray-100">
                    <div className="py-1">
                      <div className="px-4 py-2">
                        <p className="text-sm font-medium text-gray-900">
                          {currentUser?.firstName} {currentUser?.lastName}
                        </p>
                        <p className="text-xs text-gray-500">{currentUser?.email}</p>
                      </div>
                    </div>
                    <div className="py-1">
                      <Link
                        to="/profile"
                        className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                        onClick={() => setDropdownOpen(false)}
                      >
                        <FaUserCog className="mr-3 text-gray-400" />
                        Your Profile
                      </Link>
                      {/* <Link
                        to="/admin/settings"
                        className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                        onClick={() => setDropdownOpen(false)}
                      >
                        <FaCog className="mr-3 text-gray-400" />
                        Settings
                      </Link> */}
                    </div>
                    <div className="py-1">
                      <button
                        onClick={handleLogout}
                        className="flex w-full items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                      >
                        <FaSignOutAlt className="mr-3 text-gray-400" />
                        Sign out
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile menu, show/hide based on mobile menu state */}
      {mobileMenuOpen && (
        <div className="md:hidden">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3">
            {navLinks.map((link) => (
              <Link
                key={link.name}
                to={link.path}
                className={`${
                  isActive(link.path)
                    ? 'bg-blue-50 text-blue-700'
                    : 'text-gray-500 hover:bg-gray-50 hover:text-gray-900'
                } block px-3 py-2 rounded-md text-base font-medium flex items-center`}
                onClick={() => setMobileMenuOpen(false)}
              >
                {link.icon}
                {link.name}
              </Link>
            ))}
          </div>
          <div className="pt-4 pb-3 border-t border-gray-200">
            <div className="flex items-center px-5">
              <div className="flex-shrink-0">
                <div className="h-10 w-10 rounded-full bg-blue-100 flex items-center justify-center text-blue-800">
                  {currentUser?.firstName?.charAt(0) || 'A'}
                </div>
              </div>
              <div className="ml-3">
                <div className="text-base font-medium text-gray-800">{currentUser?.firstName} {currentUser?.lastName}</div>
                <div className="text-sm font-medium text-gray-500">{currentUser?.email}</div>
              </div>
              {/* <button
                className="ml-auto flex-shrink-0 p-1 rounded-full text-gray-400 hover:text-gray-500"
              >
                <FaBell className="h-6 w-6" />
              </button> */}
            </div>
            <div className="mt-3 px-2 space-y-1">
              <Link
                to="/admin/profile"
                className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:bg-gray-50 hover:text-gray-900 flex items-center"
                onClick={() => setMobileMenuOpen(false)}
              >
                <FaUserCog className="mr-2" />
                Your Profile
              </Link>
          
              <button
                onClick={handleLogout}
                className="w-full flex items-center px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:bg-gray-50 hover:text-gray-900"
              >
                <FaSignOutAlt className="mr-2" />
                Sign out
              </button>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
};

export default AdminNavbar;